module.exports = __webpack_public_path__ + "media/images/ovalEvening-d6b824c6e90cccaefb7276bc2998d58f.jpg";